// extracted by mini-css-extract-plugin
export default {"callToAction":"nszI6f4RuySRTRLj8Y0T"};